import { CreateOrgUserForm } from "@doculegis/shared";
import { Button } from "@/components/ui/button";
import { pageDescriptionMobileHiddenClassName } from "@/lib/page-action-button";
import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

interface CreateOrgUserSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  orgName: string;
  orgRoles: readonly string[];
  memberLimit: number;
  memberCount: number;
  isSubmitting?: boolean;
  error?: string | null;
  onSubmit: (values: {
    email: string;
    password: string;
    name: string;
    role: string;
  }) => Promise<void>;
}

export function CreateOrgUserSheet({
  open,
  onOpenChange,
  orgName,
  orgRoles,
  memberLimit,
  memberCount,
  isSubmitting = false,
  error,
  onSubmit,
}: CreateOrgUserSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="p-0">
        <SheetHeader>
          <SheetTitle>New user</SheetTitle>
          <SheetDescription className={pageDescriptionMobileHiddenClassName}>
            Add a member to {orgName}. Members: {memberCount} / {memberLimit}
          </SheetDescription>
        </SheetHeader>

        <SheetBody className="space-y-4">
          {error ? (
            <div className="rounded-lg border border-red-500/30 bg-red-500/15 px-4 py-3 text-sm text-red-200">
              {error}
            </div>
          ) : null}

          <CreateOrgUserForm
            id="create-org-user"
            orgRoles={orgRoles}
            layout="stack"
            onSubmit={onSubmit}
          />
        </SheetBody>

        <SheetFooter>
          <Button
            type="button"
            variant="surface"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button form="create-org-user" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Creating…" : "Create user"}
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
